import { CoreEvent } from '@carvana/core-events';
import React, { useCallback, useEffect, useState } from 'react';
import { EditOrderModal } from '|/app/navigation-rail/components/modals';
import {
  VERIFX_OPEN_EDIT_ORDER_MODAL,
  coreEventOffWithType,
  type VerifxModalEvents
} from '|/app/verifx-events';

const EditOrderModalListener: React.FC = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [editingSectionName, setEditingSectionName] = useState('');
  const [targetStep, setTargetStep] = useState<string | undefined>();

  useEffect(() => {
    const handler = (event: VerifxModalEvents['VERIFX_OPEN_EDIT_ORDER_MODAL']) => {
      setEditingSectionName(event.editingSectionName ?? '');
      setTargetStep(event.targetStep);
      setIsOpen(true);
    };
    CoreEvent.onWithType<VerifxModalEvents, typeof VERIFX_OPEN_EDIT_ORDER_MODAL>(
      VERIFX_OPEN_EDIT_ORDER_MODAL,
      handler
    );
    return () => {
      coreEventOffWithType<VerifxModalEvents, typeof VERIFX_OPEN_EDIT_ORDER_MODAL>(
        VERIFX_OPEN_EDIT_ORDER_MODAL,
        handler
      );
    };
  }, []);

  const handleClose = useCallback(() => {
    setIsOpen(false);
    setEditingSectionName('');
    setTargetStep(undefined);
  }, []);

  return (
    <EditOrderModal
      isOpen={isOpen}
      onClose={handleClose}
      editingSectionName={editingSectionName}
      targetStep={targetStep}
    />
  );
};

export default EditOrderModalListener;
